export async function getUserIP(): Promise<string> {
  try {
    const response = await fetch('https://api.ipify.org?format=json'); // Or use another service like https://ipinfo.io/json
    const data = await response.json();
    return data.ip; // `ip` is the key in the response JSON for most services
  } catch (error) {
    console.error('Error fetching IP address:', error);
    return 'Unable to fetch IP';
  }
}
